import React from 'react';
import Constant from '../../Constant';
import FadeInSection from '../FadeInSection';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { motion } from 'framer-motion';

function What() {
    const keyFeatures = [
        {
            icon: <CheckCircleOutlineIcon fontSize="medium" style={{ color: '#8046F2' }} />,
            text: 'Like a cooperative, but better.',
        },
        {
            icon: <CheckCircleOutlineIcon fontSize="medium" style={{ color: '#8046F2' }} />,
            text: 'Like saving together, but smarter.',
        },
        {
            icon: <CheckCircleOutlineIcon fontSize="medium" style={{ color: '#8046F2' }} />,
            text: 'Like growing wealth, but ethical.',
        }
    ];

    

    const container = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
            transition: { staggerChildren: 0.2 },
        },
    };

    const item = {
        hidden: { opacity: 0, y: 30 },
        show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
    };

    return (
        <FadeInSection>
            <div className="px-6 sm:px-24 mb-20 mt-20">
                <h1 className="text-text-color1 font-normal text-[24px] sm:text-[44px] mb-8">
                    What is a <span className={Constant.linearColor}>Circle</span>
                </h1>
                <p className="mt-4 text-[14px] mb-10 sm:text-[18px] font-[400] text-text-color1">
                    A Circle is more than group saving - it’s collaborative wealth-building with purpose. With Halal Wealth, your Circle doesn’t just keep money idle; it channels savings into vetted halal investments that earn returns for everyone involved. </p>
                <div className="grid sm:grid-cols-2 gap-6">
                    <motion.div
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true }}
                        variants={container}
                        className="flex flex-col"
                    >
                        <motion.h2 variants={item} className="text-text-color1 font-normal text-[18px] sm:text-[24px] mb-4">
                            Key Features
                        </motion.h2>
                        <motion.ul variants={container} className="space-y-3">
                            {keyFeatures.map((feature, index) => (
                                <motion.li key={index} variants={item} className="flex items-center gap-3">
                                    <div
                                        className="w-8 h-8 rounded-full flex items-center justify-center"
                                        style={{ backgroundColor: '#F5F1FE' }}
                                    >
                                        {feature.icon}
                                    </div>
                                    <span className="text-[14px] sm:text-[16px] font-[400] text-text-color1">
                                        {feature.text}
                                    </span>
                                </motion.li>
                            ))}
                        </motion.ul>
                    </motion.div>

                    
                </div>
            </div>
        </FadeInSection>
    );
}

export default What;